import { FC } from "react";
import { Box, Group, Switch, Text } from "@mantine/core";
import { FilterComponentProps } from ".";
import { STATUS_COLOR_MAP } from "../consts";


const StatusFilter: FC<FilterComponentProps> = ({
  onFilterControlChange,
  filterControl,
}) => {
  return (
    <Box mt="xl" ml={10} mr={5} h="85%" style={{overflowY: "scroll"}}>
      <Switch.Group
        value={filterControl.status || undefined}
        onChange={(v) => onFilterControlChange({
          ...filterControl,
          status: v,
        })}>
      {Array.from(STATUS_COLOR_MAP.keys()).map((status, index) => (
        <Group justify="space-between" my="sm" key={index}>
          <Text fz="sm" fw="bold">
            {status}
          </Text>
          <Switch
            value={status}
           />
        </Group>
      ))}
      </Switch.Group>
    </Box>
  );
};

export default StatusFilter